"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clone = exports.create = void 0;
var enumsAi_1 = require("./enumsAi");
function create() {
    return {
        mode: enumsAi_1.EAiMode.None,
        state: enumsAi_1.EAiState.None,
    };
}
exports.create = create;
function clone(state) {
    return Object.assign({}, state);
}
exports.clone = clone;
